/* ============================================
   MR CIRCUIT THEME — MAIN JS
   ============================================ */

// Signal JS is available so CSS can progressively enhance.
document.documentElement.classList.remove("no-js");
document.documentElement.classList.add("js");

// --- Hero Carousel ---
let heroIndex = 0;
let heroTimer;
const heroSlides = document.getElementById("heroSlides");
const heroDots = document.querySelectorAll(".hero-dot");
const heroTotal = document.querySelectorAll(".hero-slide").length;

function heroGoTo(index) {
  if (!heroSlides || !heroTotal) return;
  heroIndex = index;
  heroSlides.style.transform = `translateX(-${heroIndex * 100}%)`;
  heroDots.forEach((d, i) => d.classList.toggle("active", i === heroIndex));
  resetHeroTimer();
}

function heroSlide(dir) {
  if (!heroTotal) return;
  heroGoTo((heroIndex + dir + heroTotal) % heroTotal);
}

function resetHeroTimer() {
  if (!heroTotal) return;
  clearInterval(heroTimer);
  heroTimer = setInterval(() => heroSlide(1), 6000);
}

const heroEl = document.getElementById("hero");
if (heroEl && heroSlides && heroTotal) {
  heroEl.addEventListener("mouseenter", () => clearInterval(heroTimer));
  heroEl.addEventListener("mouseleave", resetHeroTimer);

  let touchStartX = 0;
  heroEl.addEventListener("touchstart", (e) => {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  heroEl.addEventListener("touchend", (e) => {
    const diff = touchStartX - e.changedTouches[0].screenX;
    if (Math.abs(diff) > 50) heroSlide(diff > 0 ? 1 : -1);
  }, { passive: true });

  resetHeroTimer();
}

// --- Mobile Hamburger ---
const hamburger = document.querySelector(".hamburger");
const mobileNav = document.getElementById("mobileNav");

if (hamburger && mobileNav) {
  hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("active");
    mobileNav.classList.toggle("active");
    document.body.style.overflow = mobileNav.classList.contains("active") ? "hidden" : "";
  });
}

function closeMobileNav() {
  if (!hamburger || !mobileNav) return;
  hamburger.classList.remove("active");
  mobileNav.classList.remove("active");
  document.body.style.overflow = "";
}

// Fallback for Shopify navigation scope limits: add the components shortcut if
// the rendered menu does not include it yet.
(function () {
  const componentsHref = "/pages/electronic-parts-page?filter=components#parts-filter";

  function addComponentsLink(nav) {
    if (!nav || nav.querySelector('a[href*="filter=components"]')) return;

    const targetLink = Array.from(nav.querySelectorAll("a")).find((link) => {
      const label = link.textContent.trim().toLowerCase();
      return label === "lab replacement parts" || label === "electronic parts";
    });

    if (!targetLink) return;

    const link = document.createElement("a");
    link.href = componentsHref;
    link.textContent = "Electronic Components";
    if (nav.id === "mobileNav") {
      link.addEventListener("click", closeMobileNav);
    }

    targetLink.insertAdjacentElement("afterend", link);
  }

  addComponentsLink(document.querySelector(".nav-links"));
  addComponentsLink(document.getElementById("mobileNav"));
})();

// Gary requested the header "Shop Labs" CTA be removed. Keep this fallback so
// cached header sections cannot keep showing the old green button.
(function () {
  document.querySelectorAll(".nav-ctas .btn-green, #mobileNav .btn-green").forEach((link) => {
    if (link.textContent.trim().toLowerCase() === "shop labs") {
      link.remove();
    }
  });
})();

// Keep the long desktop nav balanced: logo left, nav centered, icons right.
(function () {
  const styleId = "mc-header-layout-fix";
  if (document.getElementById(styleId)) return;

  const style = document.createElement("style");
  style.id = styleId;
  style.textContent = `
    .header-inner {
      max-width: none !important;
      width: 100% !important;
      display: grid !important;
      grid-template-columns: minmax(220px, 1fr) max-content minmax(150px, 1fr) !important;
      align-items: center !important;
      height: 76px !important;
      padding: 0 clamp(28px, 4vw, 72px) !important;
      column-gap: clamp(24px, 3vw, 56px) !important;
    }
    .logo {
      justify-self: start !important;
      min-width: max-content !important;
      gap: 10px !important;
    }
    .nav-links {
      justify-self: center !important;
      justify-content: center !important;
      min-width: max-content !important;
      gap: clamp(16px, 1.25vw, 26px) !important;
    }
    .nav-links a {
      font-size: clamp(0.84rem, 0.74vw, 0.94rem) !important;
      letter-spacing: -0.015em !important;
    }
    .nav-ctas {
      justify-self: end !important;
      align-items: center !important;
      gap: 18px !important;
    }
    .header-search-btn,
    .header-cart {
      width: 46px !important;
      height: 46px !important;
      border-radius: 999px !important;
    }
    .header-search-btn {
      background: #f7f8fa !important;
    }
    @media (max-width: 1280px) {
      .header-inner {
        grid-template-columns: minmax(180px, 1fr) max-content minmax(120px, 1fr) !important;
        padding: 0 clamp(18px, 2.4vw, 34px) !important;
        column-gap: 18px !important;
      }
      .nav-links { gap: 13px !important; }
      .nav-links a { font-size: 0.82rem !important; }
      .logo__img { height: 38px !important; }
      .logo__text strong { font-size: 1.12rem !important; }
      .logo__text em { font-size: 0.66rem !important; letter-spacing: 0.14em !important; }
    }
    @media (max-width: 1120px) {
      .header-inner { grid-template-columns: minmax(82px, 1fr) max-content minmax(104px, 1fr) !important; }
      .logo__text { display: none !important; }
    }
    @media (max-width: 1180px) {
      .header-inner { grid-template-columns: auto minmax(0, 1fr) auto auto !important; }
      .nav-links { display: none !important; }
      .nav-ctas { grid-column: 3 !important; }
      .hamburger {
        display: flex !important;
        grid-column: 4 !important;
        justify-self: end !important;
      }
    }
  `;
  document.head.appendChild(style);
})();

// --- Scroll Reveal ---
const revealEls = document.querySelectorAll('.reveal');
if (revealEls.length) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  revealEls.forEach(el => revealObserver.observe(el));
}

// --- Keyboard Navigation for Hero ---
document.addEventListener('keydown', (e) => {
  if (e.key === 'ArrowLeft' && heroTotal) heroSlide(-1);
  if (e.key === 'ArrowRight' && heroTotal) heroSlide(1);
});

/* ============================================
   LAB SEQUENCE INTERACTIVITY
   Reads content from data-* attributes on each .sequence-step button
   (rendered by sections/lab-sequence.liquid).
   ============================================ */
(function () {
  const steps = Array.from(document.querySelectorAll(".sequence-step"));
  if (!steps.length) return;

  const numberEl = document.getElementById("sequenceNumber");
  const kickerEl = document.getElementById("sequenceKicker");
  const titleEl = document.getElementById("sequenceTitle");
  const descriptionEl = document.getElementById("sequenceDescription");
  const imageWrap = document.getElementById("sequenceImageWrap");
  const bulletsEl = document.getElementById("sequenceBullets");
  const ctaEl = document.getElementById("sequenceCta");

  function setActive(step) {
    steps.forEach((s) => s.classList.toggle("is-active", s === step));
    if (numberEl) numberEl.textContent = step.dataset.number || "";
    if (kickerEl) kickerEl.textContent = step.dataset.kicker || "";
    if (titleEl) titleEl.textContent = step.dataset.title || "";
    if (descriptionEl) descriptionEl.textContent = step.dataset.description || "";
    if (imageWrap && step.dataset.image) {
      imageWrap.innerHTML = `<img id="sequenceImage" src="${step.dataset.image}" alt="${(step.dataset.title || '').replace(/"/g, '&quot;')}" loading="lazy">`;
    }
    if (bulletsEl) {
      try {
        const bullets = JSON.parse(step.dataset.bullets || "[]");
        bulletsEl.innerHTML = bullets.map((item) => `<li>${item}</li>`).join("");
      } catch (e) { /* malformed JSON — leave bullets as-is */ }
    }
    if (ctaEl && step.dataset.productLink && step.dataset.productLink !== "#") {
      ctaEl.setAttribute("href", step.dataset.productLink);
    }
  }

  steps.forEach((step) => {
    step.addEventListener("click", () => {
      const productLink = step.dataset.productLink;
      if (productLink && productLink !== "#") {
        window.location.href = productLink;
        return;
      }
      setActive(step);
    });
    step.addEventListener("mouseenter", () => {
      if (window.matchMedia("(min-width: 1101px)").matches) setActive(step);
    });
  });
})();

/* ============================================
   LAB PRODUCT PAGE INTERACTIVITY
   ============================================ */
(function () {
  const mainImage = document.getElementById("labGalleryMain");
  const thumbs = Array.from(document.querySelectorAll(".lab-thumb"));

  if (mainImage && thumbs.length) {
    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
        mainImage.src = thumb.dataset.image;
        mainImage.alt = thumb.dataset.alt;
      });
    });
  }

  const experimentTabs = Array.from(document.querySelectorAll(".experiment-tab"));
  const eyebrowEl = document.getElementById("experimentEyebrow");
  const titleEl = document.getElementById("experimentTitle");
  const copyEl = document.getElementById("experimentCopy");
  const bulletsEl = document.getElementById("experimentBullets");

  const experimentContent = {
    foundations: {
      eyebrow: "Experiment track 01",
      title: "From components to confidence",
      copy: "Start with the physical basics: what each component is, what it does, and how current behaves once students actually plug the parts into the board.",
      bullets: [
        "Introduces resistor behavior, polarity, and simple circuit flow",
        "Builds comfort with the breadboard before larger projects appear",
        "Keeps the first wins fast, visible, and easy to teach"
      ]
    },
    timers: {
      eyebrow: "Experiment track 11",
      title: "The 555 timer makes the course feel serious",
      copy: "By the time students reach timer behavior, the lab has already earned their trust. This is where the product stops feeling introductory and starts feeling like real electronics training.",
      bullets: [
        "Connects earlier component understanding into a more complete system",
        "Gives teachers a credible moment to talk about timing and control",
        "Adds technical depth without losing the build-first teaching style"
      ]
    },
    projects: {
      eyebrow: "Experiment track 24",
      title: "Real projects give the page its emotional payoff",
      copy: "The projects are what make the product memorable: alarms, lights, sirens, detectors, and fun builds that prove the parts are doing something students can actually see and hear.",
      bullets: [
        "Turns theory into outcomes students remember and talk about",
        "Creates stronger parent and teacher proof than abstract specs alone",
        "Supports the product's claim that students build real working circuits"
      ]
    },
    platform: {
      eyebrow: "Experiment track 34",
      title: "The digital layer keeps the system from looking one-dimensional",
      copy: "The online platform should appear as reinforcement, not as a separate product. It extends the physical kit with lessons, quizzes, and certificates that help the kit stick in real classrooms.",
      bullets: [
        "Supports review and pacing after the hands-on build session",
        "Lets the product page sell more than parts in a box",
        "Creates a clean bridge into future Shopify sections for digital support"
      ]
    }
  };

  if (experimentTabs.length && eyebrowEl && titleEl && copyEl && bulletsEl) {
    experimentTabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const content = experimentContent[tab.dataset.experiment];
        if (!content) return;

        experimentTabs.forEach((item) => item.classList.remove("is-active"));
        tab.classList.add("is-active");
        eyebrowEl.textContent = content.eyebrow;
        titleEl.textContent = content.title;
        copyEl.textContent = content.copy;
        bulletsEl.innerHTML = content.bullets.map((item) => `<li>${item}</li>`).join("");
      });
    });
  }
})();

/* ============================================
   INTERACTIVE PLATFORM DEMOS
   ============================================ */
(function () {
  // === Quiz Demo ===
  const quizOpts = document.querySelectorAll(".lcd-opt");
  const quizFeedback = document.querySelector(".lcd-feedback");
  if (quizOpts.length && quizFeedback) {
    quizOpts.forEach((btn) => {
      btn.addEventListener("click", () => {
        // Disable all buttons
        quizOpts.forEach((b) => b.classList.add("is-disabled"));
        
        const isCorrect = btn.dataset.correct === "true";
        btn.classList.add(isCorrect ? "is-correct" : "is-wrong");
        
        // Show the correct one if wrong
        if (!isCorrect) {
          quizOpts.forEach((b) => {
            if (b.dataset.correct === "true") b.classList.add("is-correct");
          });
        }
        
        // Show feedback
        quizFeedback.hidden = false;
        quizFeedback.classList.add(isCorrect ? "is-correct" : "is-wrong");
        quizFeedback.querySelector(".lcd-feedback__icon").textContent = isCorrect ? "✅" : "❌";
        quizFeedback.querySelector(".lcd-feedback__text").textContent = isCorrect
          ? "Correct! Resistance is measured in Ohms (Ω)."
          : "Not quite — the unit of resistance is Ohms (Ω).";
      });
    });
  }


  // === Circuit Game (Ohm's Law) ===
  const ohmAnswer = document.getElementById("ohmAnswer");
  const ohmSubmit = document.getElementById("ohmSubmit");
  const ohmFeedback = document.getElementById("ohmFeedback");
  
  if (ohmSubmit && ohmAnswer && ohmFeedback) {
    ohmSubmit.addEventListener("click", () => {
      const answer = parseFloat(ohmAnswer.value);
      const correctAnswer = 4; // 36V / 9A = 4Ω
      const feedbackIcon = ohmFeedback.querySelector(".circuit-feedback__icon");
      const feedbackText = ohmFeedback.querySelector(".circuit-feedback__text");
      
      if (isNaN(answer) || ohmAnswer.value === "") return;
      
      ohmFeedback.hidden = false;
      ohmFeedback.classList.remove("is-correct", "is-wrong");
      
      if (answer === correctAnswer) {
        ohmFeedback.classList.add("is-correct");
        feedbackIcon.textContent = "✅";
        feedbackText.textContent = "Correct! 36V ÷ 9A = 4Ω";
        ohmSubmit.classList.add("is-disabled");
        ohmAnswer.disabled = true;
      } else {
        ohmFeedback.classList.add("is-wrong");
        feedbackIcon.textContent = "❌";
        feedbackText.textContent = "Not quite — try again! (Hint: V ÷ I = R)";
        ohmAnswer.value = "";
        ohmAnswer.focus();
      }
    });
    
    // Allow Enter key to submit
    ohmAnswer.addEventListener("keydown", (e) => {
      if (e.key === "Enter") ohmSubmit.click();
    });
  }

  // === Certificate Date ===
  const certDate = document.getElementById("certDate");
  if (certDate) {
    const now = new Date();
    certDate.textContent = now.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  // === Workbench Tab Switching ===
  const benchTabs = document.querySelectorAll(".bench-tab");
  const devices = document.querySelectorAll(".workbench__stage .device");
  
  benchTabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.device;
      
      // Update tabs
      benchTabs.forEach(t => t.classList.remove("bench-tab--active"));
      tab.classList.add("bench-tab--active");
      
      // Update devices
      devices.forEach(d => {
        d.classList.remove("device--active");
        if (d.dataset.device === target) {
          d.classList.add("device--active");
        }
      });
    });
  });
})();

/* ============================================
   COLLECTION PAGE — QTY STEPPERS + CHIP FILTERS
   Used by product-row.liquid (list table) and .coll-chip on both templates.
   ============================================ */
function listQty(btn, dir) {
  const wrap = btn.closest(".pl-qty");
  if (!wrap) return;
  const input = wrap.querySelector(".pl-qty__input");
  if (!input) return;
  input.value = Math.max(1, parseInt(input.value || 1, 10) + dir);
}

(function () {
  const chips = document.querySelectorAll(".coll-chip");
  if (!chips.length) return;

  chips.forEach((chip) => {
    chip.addEventListener("click", () => {
      chips.forEach((c) => c.classList.remove("is-active"));
      chip.classList.add("is-active");
      const filter = chip.dataset.filter;

      // Grid layout: filter .kit-card and .kit-featured wrappers via data-filter-type
      document.querySelectorAll("[data-filter-type]").forEach((el) => {
        if (filter === "all" || el.dataset.filterType === filter) {
          el.style.display = "";
        } else {
          el.style.display = "none";
        }
      });

      // List layout: filter .comp-section blocks via data-category
      document.querySelectorAll(".comp-section").forEach((section) => {
        if (filter === "all") {
          section.style.display = "";
        } else if (section.dataset.category === filter) {
          section.style.display = "block";
        } else {
          section.style.display = "none";
        }
      });
      // Toggle the "Show all categories" button visibility
      const showMoreWrap = document.querySelector(".parts-show-more");
      if (showMoreWrap) {
        showMoreWrap.style.display = filter === "all" ? "" : "none";
      }
    });
  });
})();

/* ============================================
   SIMPLE PDP — qty stepper + gallery thumbs
   Used by sections/main-product-simple.liquid.
   ============================================ */
function spQty(dir) {
  const input = document.getElementById("spQtyInput");
  if (!input) return;
  const next = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
  input.value = next;
  const unit = parseFloat(input.dataset.unitPrice || 0);
  const priceEl = document.getElementById("spAddPrice");
  if (priceEl && unit) {
    const total = (unit * next / 100).toFixed(2);
    priceEl.textContent = "$" + total;
  }
}

(function () {
  const main = document.getElementById("spMainImg");
  const thumbs = document.querySelectorAll(".sp-thumb");
  if (!main || !thumbs.length) return;
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      const src = thumb.dataset.src;
      if (!src) return;
      thumbs.forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
      main.src = src;
    });
  });
})();

/* ============================================
   LAB PDP — qty stepper, gallery, sticky buy bar
   Used by sections/main-product-lab.liquid.
   ============================================ */
function pdpQty(dir) {
  const input = document.getElementById("pdpQtyInput");
  if (!input) return;
  const next = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
  input.value = next;
  const unit = parseFloat(input.dataset.unitPrice || 0);
  const priceEl = document.getElementById("pdpAddPrice");
  if (priceEl && unit) {
    priceEl.textContent = "$" + (unit * next / 100).toFixed(2);
  }
}

(function () {
  const main = document.getElementById("pdpMainImg");
  const thumbs = document.querySelectorAll(".pdp-thumb[data-src]");
  if (main && thumbs.length) {
    thumbs.forEach((t) => {
      t.addEventListener("click", () => {
        document.querySelectorAll(".pdp-thumb").forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
        main.src = t.dataset.src;
      });
    });
  }

  // Sticky buy bar appears after scrolling past the hero
  const bar = document.getElementById("pdpStickyBar");
  const hero = document.getElementById("buy");
  if (bar && hero) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // When the hero leaves the viewport top, reveal the sticky bar
          if (entry.boundingClientRect.bottom < 0) {
            bar.classList.add("is-visible");
            bar.setAttribute("aria-hidden", "false");
          } else {
            bar.classList.remove("is-visible");
            bar.setAttribute("aria-hidden", "true");
          }
        });
      },
      { threshold: 0, rootMargin: "0px" }
    );
    io.observe(hero);
  }
})();

/* ============================================
   PDP — scroll-reveal for sections that ship with opacity:0
   (.pdp-meet__row, .pdp-lessons__grid, etc.)
   ============================================ */
(function () {
  const selectors = [
    ".pdp-meet__row",
    ".pdp-lessons__grid",
    ".pdp-outcomes__list",
    ".pdp-box__inner",
    ".pdp-classroom__inner",
    ".pdp-faq__list",
    ".kits-section__header",
    ".kits-grid",
    ".kits-section__note",
    ".included-grid",
    ".classroom-use__inner > div",
    ".cu-stat-grid",
    ".cu-careers",
    ".story-beat",
    ".mission-pillar",
    ".lab-showcase-card",
    ".about-schools__header",
    ".about-mission__header",
    ".about-labs__header",
  ];
  const targets = document.querySelectorAll(selectors.join(","));
  if (!targets.length) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReduced) {
    targets.forEach((t) => t.classList.add("is-in"));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
  );
  targets.forEach((t) => io.observe(t));
})();

/* ============================================
   MC1-SET — count-up animation on .cu-stat__val
   Parses a numeric token from the element's text (e.g. "32",
   "$164", "3+", "~$2") and animates from 0 to that number when
   the stat grid becomes visible. Non-numeric prefixes/suffixes
   (e.g. "$", "+", "~") are preserved.
   ============================================ */
(function () {
  const grid = document.querySelector(".cu-stat-grid");
  if (!grid) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const stats = grid.querySelectorAll(".cu-stat__val");
  if (!stats.length) return;

  // Snapshot each stat's final text and parse a number from it
  const frozen = [];
  stats.forEach((el) => {
    const txt = el.textContent.trim();
    const m = txt.match(/(-?\d[\d,]*\.?\d*)/);
    if (!m) return;
    const target = parseFloat(m[1].replace(/,/g, ""));
    if (isNaN(target) || target < 1) return;
    const parts = txt.split(m[1]);
    frozen.push({ el, prefix: parts[0] || "", suffix: parts[1] || "", target, orig: txt });
    el.textContent = parts[0] + "0" + (parts[1] || "");
    el.dataset.count = "pending";
  });

  if (!frozen.length) return;

  const animate = (item) => {
    const duration = 1400;
    const start = performance.now();
    const step = (now) => {
      const elapsed = now - start;
      const progress = Math.min(1, elapsed / duration);
      const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      const current = item.target * eased;
      const rendered = item.target >= 10
        ? Math.round(current).toLocaleString()
        : current.toFixed(current === Math.floor(current) && item.target === Math.floor(item.target) ? 0 : 2);
      item.el.textContent = item.prefix + rendered + item.suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        item.el.textContent = item.orig; // snap to original text to preserve <em> etc.
      }
    };
    requestAnimationFrame(step);
  };

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          frozen.forEach(animate);
          io.disconnect();
        }
      });
    },
    { threshold: 0.3 }
  );
  io.observe(grid);
})();

/* ============================================
   Electronic Parts hub: "Show all categories" reveal
   ============================================ */
(function () {
  const btn = document.getElementById("partsShowMore");
  if (!btn) return;
  btn.addEventListener("click", () => {
    document.querySelectorAll(".parts-hidden").forEach((el) => el.classList.add("is-revealed"));
    btn.parentElement.style.display = "none";
  });
})();

/* ============================================
   Product return context
   Remembers the parts list or collection a customer came from.
   ============================================ */
(function () {
  const storageKey = "mrcProductReturnContext";

  document.addEventListener("click", (event) => {
    const link = event.target.closest("[data-product-return-source]");
    if (!link) return;

    const title = link.dataset.returnTitle || "";
    const url = link.dataset.returnUrl || "";
    if (!title || !url) return;

    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ title, url }));
    } catch (error) {
      // Ignore storage failures; the product page has a normal fallback link.
    }
  });

  const returnLink = document.querySelector("[data-product-return-link]");
  if (!returnLink) return;

  let context = {
    title: returnLink.dataset.fallbackTitle || "Electronic Parts",
    url: returnLink.dataset.fallbackUrl || "/pages/electronic-parts-page"
  };

  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || "null");
    if (saved && saved.title && saved.url) context = saved;
  } catch (error) {
    // Keep fallback context.
  }

  if (context.url) returnLink.setAttribute("href", context.url);
  const text = returnLink.querySelector("[data-product-return-text]");
  if (text) text.textContent = `Back to ${context.title}`;
})();

/* ============================================
   Electronic Parts hub: show full rendered product lists
   Expands older cached tables that still include the previous row cap.
   ============================================ */
(function () {
  document.querySelectorAll(".comp-section .prod-list[data-initial]").forEach((table) => {
    table.classList.add("parts-expanded");
  });

  document.querySelectorAll(".parts-load-more").forEach((wrap) => {
    if (!wrap.querySelector("a")) wrap.remove();
  });

  document.querySelectorAll(".parts-load-more__btn").forEach((btn) => {
    btn.remove();
  });
})();

/* ============================================
   PREDICTIVE SEARCH (ajax dropdown)
   Mounts on any <form data-ps-form> with [data-ps-input] + [data-ps-panel]
   Uses Shopify /search/suggest.json
   ============================================ */
(function () {
  var forms = document.querySelectorAll("[data-ps-form]");
  if (!forms.length) return;

  // Shopify's /search/suggest.json returns product price as a decimal-dollar string
  // (e.g. "5.95"), NOT cents. Parse and format — don't divide.
  function money(price) {
    if (price == null || price === "") return "";
    var num = typeof price === "number" ? price : parseFloat(price);
    if (isNaN(num)) return "";
    return "$" + num.toFixed(2);
  }

  function esc(s) {
    if (s == null) return "";
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function stripHtml(s) {
    if (!s) return "";
    return s.replace(/<[^>]*>/g, "");
  }

  function highlight(text, q) {
    if (!text || !q) return esc(text);
    var clean = stripHtml(text);
    var re = new RegExp("(" + q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "ig");
    return esc(clean).replace(re, "<mark>$1</mark>");
  }

  function renderPanel(data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
    var pages = (data.resources && data.resources.results && data.resources.results.pages) || [];
    var total = products.length + articles.length + pages.length;

    if (total === 0) {
      return (
        '<div class="ps-empty">' +
          '<strong>No matches for &ldquo;' + esc(query) + '&rdquo;</strong>' +
          '<span>Try a different spelling or a broader term.</span>' +
        '</div>'
      );
    }

    var html =
      '<div class="ps-enter-hint">' +
        '<span>Press <kbd>Enter</kbd> to view all results for &ldquo;' + esc(query) + '&rdquo;.</span>' +
      '</div>';

    if (products.length > 0) {
      html += '<div class="ps-section"><div class="ps-section__head">Products <span>' + products.length + '</span></div>';
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var img = (p.featured_image && p.featured_image.url) || p.image || "";
        var sku = (p.variants && p.variants[0] && p.variants[0].sku) || "";
        html +=
          '<a href="' + esc(p.url) + '" class="ps-item ps-item--prod" data-ps-opt>' +
            '<div class="ps-item__img">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>') +
            '</div>' +
            '<div class="ps-item__body">' +
              '<span class="ps-item__title">' + highlight(p.title, query) + '</span>' +
              (sku ? '<span class="ps-item__meta">SKU ' + esc(sku) + '</span>' : '') +
            '</div>' +
            '<span class="ps-item__price">' + money(p.price) + '</span>' +
          '</a>';
      }
      html += "</div>";
    }

    if (articles.length > 0) {
      html += '<div class="ps-section"><div class="ps-section__head">Articles <span>' + articles.length + '</span></div>';
      for (var j = 0; j < articles.length; j++) {
        var a = articles[j];
        html +=
          '<a href="' + esc(a.url) + '" class="ps-item ps-item--art" data-ps-opt>' +
            '<span class="ps-item__ic"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5V4.5A2.5 2.5 0 016.5 2z"/></svg></span>' +
            '<div class="ps-item__body">' +
              '<span class="ps-item__title">' + highlight(a.title, query) + '</span>' +
              (a.summary_html ? '<span class="ps-item__meta">' + esc(stripHtml(a.summary_html).slice(0, 80)) + '</span>' : "") +
            '</div>' +
          '</a>';
      }
      html += "</div>";
    }

    if (pages.length > 0) {
      html += '<div class="ps-section"><div class="ps-section__head">Pages <span>' + pages.length + '</span></div>';
      for (var k = 0; k < pages.length; k++) {
        var pg = pages[k];
        html +=
          '<a href="' + esc(pg.url) + '" class="ps-item ps-item--page" data-ps-opt>' +
            '<span class="ps-item__ic"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg></span>' +
            '<div class="ps-item__body">' +
              '<span class="ps-item__title">' + highlight(pg.title, query) + '</span>' +
            '</div>' +
          '</a>';
      }
      html += "</div>";
    }

    html +=
      '<a href="/search?q=' + encodeURIComponent(query) + '&type=product,article,page" class="ps-all">' +
        'See all ' + total + ' result' + (total === 1 ? "" : "s") + ' for &ldquo;' + esc(query) + '&rdquo;' +
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
      '</a>';

    return html;
  }

  function renderLoading() {
    return '<div class="ps-loading"><span class="ps-dot"></span><span class="ps-dot"></span><span class="ps-dot"></span></div>';
  }

  forms.forEach(function (form) {
    var input = form.querySelector("[data-ps-input]");
    var panel = form.parentElement.querySelector("[data-ps-panel]");
    if (!input || !panel) return;

    var timer = null;
    var activeReq = null;
    var optIndex = -1;

    function show() {
      panel.hidden = false;
      form.setAttribute("data-ps-open", "true");
    }
    function hide() {
      panel.hidden = true;
      form.removeAttribute("data-ps-open");
      optIndex = -1;
    }
    function opts() {
      return panel.querySelectorAll("[data-ps-opt]");
    }
    function focusOpt(i) {
      var list = opts();
      list.forEach(function (o) { o.classList.remove("is-focused"); });
      if (i >= 0 && i < list.length) {
        list[i].classList.add("is-focused");
        list[i].scrollIntoView({ block: "nearest" });
      }
    }

    function query(q) {
      if (activeReq && activeReq.abort) activeReq.abort();
      var controller = new AbortController();
      activeReq = controller;

      panel.innerHTML = renderLoading();
      show();

      var url = "/search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,article,page" +
        "&resources[limit]=6" +
        "&resources[options][unavailable_products]=last";

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
          // Shopify's /search/suggest.json doesn't index SKU. If no products matched,
          // fall back to /search?view=json which hits the full-text search that DOES.
          if (prods.length === 0) {
            return fetch("/search?view=json&type=product&q=" + encodeURIComponent(q), { signal: controller.signal })
              .then(function (r) { return r.ok ? r.json() : []; })
              .then(function (fallbackProds) {
                if (Array.isArray(fallbackProds) && fallbackProds.length > 0) {
                  data.resources = data.resources || { results: {} };
                  data.resources.results = data.resources.results || {};
                  data.resources.results.products = fallbackProds;
                }
                panel.innerHTML = renderPanel(data, q);
              })
              .catch(function () { panel.innerHTML = renderPanel(data, q); });
          }
          panel.innerHTML = renderPanel(data, q);
        })
        .catch(function (err) {
          if (err.name === "AbortError") return;
          panel.innerHTML = '<div class="ps-empty"><strong>Couldn&rsquo;t load results.</strong><span>Try again in a moment.</span></div>';
        });
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      if (timer) clearTimeout(timer);
      optIndex = -1;
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { query(q); }, 220);
    });

    input.addEventListener("focus", function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) show();
    });

    input.addEventListener("keydown", function (e) {
      if (panel.hidden) return;
      var list = opts();
      if (e.key === "ArrowDown") {
        e.preventDefault();
        optIndex = Math.min(optIndex + 1, list.length - 1);
        focusOpt(optIndex);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        optIndex = Math.max(optIndex - 1, -1);
        if (optIndex === -1) {
          list.forEach(function (o) { o.classList.remove("is-focused"); });
        } else {
          focusOpt(optIndex);
        }
      } else if (e.key === "Enter") {
        if (optIndex >= 0 && list[optIndex]) {
          e.preventDefault();
          window.location.href = list[optIndex].getAttribute("href");
        }
      } else if (e.key === "Escape") {
        hide();
      }
    });

    document.addEventListener("click", function (e) {
      if (!form.contains(e.target) && !panel.contains(e.target)) hide();
    });
  });

  // Header open/close
  var hBtn = document.getElementById("headerSearchBtn");
  var hPanel = document.getElementById("headerSearch");
  var hOverlay = document.getElementById("headerSearchOverlay");
  if (hBtn && hPanel) {
    var hInput = hPanel.querySelector("[data-ps-input]");
    var hClose = hPanel.querySelector("[data-ps-close]");

    function openHeaderSearch() {
      hPanel.hidden = false;
      if (hOverlay) hOverlay.hidden = false;
      hBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      setTimeout(function () { hInput && hInput.focus(); }, 50);
    }
    function closeHeaderSearch() {
      hPanel.hidden = true;
      if (hOverlay) hOverlay.hidden = true;
      hBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      if (hInput) hInput.value = "";
      var p = hPanel.querySelector("[data-ps-panel]");
      if (p) { p.hidden = true; p.innerHTML = ""; }
    }

    hBtn.addEventListener("click", function () {
      if (hPanel.hidden) openHeaderSearch(); else closeHeaderSearch();
    });
    if (hClose) hClose.addEventListener("click", closeHeaderSearch);
    if (hOverlay) hOverlay.addEventListener("click", closeHeaderSearch);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !hPanel.hidden) closeHeaderSearch();
    });
    // Keyboard shortcut: / to open
    document.addEventListener("keydown", function (e) {
      if (e.key === "/" && document.activeElement.tagName !== "INPUT" && document.activeElement.tagName !== "TEXTAREA") {
        e.preventDefault();
        if (hPanel.hidden) openHeaderSearch();
      }
    });
  }
})();

/* ============================================
   Electronic Parts hub: two-level chip filter
   Top row = groups (Electronic Components / Lab Replacement Parts / ...).
   Click a group → reveal its sub-row + filter sections to that group.
   Click a sub → narrow to a component family or one specific collection.
   Click "All parts" → reset, hide all sub-rows.
   ============================================ */
(function () {
  const filter = document.querySelector(".parts-filter2");
  if (!filter) return;

  const topBtns = filter.querySelectorAll(".pf-top");
  const subRows = filter.querySelectorAll(".parts-filter2__subs");
  const sections = document.querySelectorAll(".comp-section");
  const showMoreWrap = document.querySelector(".parts-show-more");

  function showSections(predicate) {
    let anyInitialHidden = false;
    sections.forEach((section) => {
      const match = predicate(section);
      section.style.display = match ? "" : "none";
      // When filtering, override the default "hidden past initial limit" behavior
      if (match) section.classList.remove("parts-hidden");
      if (!match && section.dataset.initial === "false") anyInitialHidden = true;
    });
    if (showMoreWrap) {
      showMoreWrap.style.display = predicate === showAll ? "" : "none";
    }
  }

  function showAll(section) {
    // When "All parts" is selected, respect the initial-categories limit
    return section.dataset.initial === "true" || section.classList.contains("is-revealed");
  }

  function setActiveTop(btn) {
    topBtns.forEach((b) => b.classList.remove("is-active"));
    btn.classList.add("is-active");
  }

	  function hideAllSubs() {
	    subRows.forEach((row) => row.setAttribute("hidden", ""));
	  }

	  function revealDetailSubRow(activeTopGroup, detailGroup) {
	    subRows.forEach((row) => {
	      const group = row.dataset.group;
	      if (group !== activeTopGroup && group !== detailGroup) {
	        row.setAttribute("hidden", "");
	      }
	    });

	    const detailRow = filter.querySelector(
	      `.parts-filter2__subs[data-group="${CSS.escape(detailGroup)}"]`
	    );
	    if (detailRow) detailRow.removeAttribute("hidden");
	  }

  function clearSubActive() {
    filter.querySelectorAll(".pf-sub").forEach((s) => s.classList.remove("is-active"));
  }

  topBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const group = btn.dataset.group;
      setActiveTop(btn);
      clearSubActive();
      hideAllSubs();

      if (group === "all") {
        // Restore default view: respect initial-limit, show "Show all" button
        sections.forEach((section) => {
          section.style.display = "";
          if (section.dataset.initial === "false") {
            section.classList.add("parts-hidden");
          }
        });
        if (showMoreWrap) showMoreWrap.style.display = "";
        return;
      }

      // Reveal this group's sub-row
      const subRow = filter.querySelector(
        `.parts-filter2__subs[data-group="${CSS.escape(group)}"]`
      );
      if (subRow) subRow.removeAttribute("hidden");

      // Filter sections to any handle in this group
      const handles = (btn.dataset.handles || "").trim().split(/\s+/).filter(Boolean);
      const handleSet = new Set(handles);
      sections.forEach((section) => {
        const match = handleSet.has(section.dataset.category);
        section.style.display = match ? "" : "none";
        if (match) section.classList.remove("parts-hidden");
      });
      if (showMoreWrap) showMoreWrap.style.display = "none";
    });
  });

	  filter.querySelectorAll(".pf-sub").forEach((btn) => {
	    btn.addEventListener("click", () => {
	      const handle = btn.dataset.filter;
	      const handles = (btn.dataset.handles || "").trim().split(/\s+/).filter(Boolean);
	      const handleSet = new Set(handles);
	      const detailGroup = btn.dataset.detailGroup;
	      // Toggle off if already active
      if (btn.classList.contains("is-active")) {
        btn.classList.remove("is-active");
        // Revert to showing the whole group
        const activeTop = filter.querySelector(".pf-top.is-active");
        if (activeTop) activeTop.click();
        return;
      }
	      clearSubActive();
	      btn.classList.add("is-active");
	      if (detailGroup) {
	        const activeTop = filter.querySelector(".pf-top.is-active");
	        revealDetailSubRow(activeTop ? activeTop.dataset.group : "", detailGroup);
	      }
	      sections.forEach((section) => {
	        const match = handleSet.size > 0 ? handleSet.has(section.dataset.category) : section.dataset.category === handle;
	        section.style.display = match ? "" : "none";
        if (match) section.classList.remove("parts-hidden");
      });
      if (showMoreWrap) showMoreWrap.style.display = "none";
    });
  });

  function getInitialTopGroup() {
    let initialGroup = "replacements";

    try {
      const params = new URLSearchParams(window.location.search);
      const requestedFilter = (
        params.get("filter") ||
        params.get("parts") ||
        params.get("view") ||
        ""
      ).toLowerCase();
      const hashFilter = window.location.hash.replace("#", "").toLowerCase();

      if (
        requestedFilter === "components" ||
        requestedFilter === "electronic-components" ||
        hashFilter === "components" ||
        hashFilter === "electronic-components"
      ) {
        initialGroup = "components";
      }
    } catch (error) {
      initialGroup = "replacements";
    }

    return initialGroup;
  }

  const initialTopGroup = getInitialTopGroup();
  const defaultTop =
    filter.querySelector(`.pf-top[data-group="${initialTopGroup}"]`) ||
    filter.querySelector('.pf-top[data-group="replacements"]');
  if (defaultTop) defaultTop.click();
  if (initialTopGroup === "components") {
    const defaultComponentSub =
      filter.querySelector('.parts-filter2__subs[data-group="components"] .pf-sub[data-detail-group="resistors"]') ||
      filter.querySelector('.parts-filter2__subs[data-group="components"] .pf-sub');
    if (defaultComponentSub) defaultComponentSub.click();
  }
})();

/* ============================================
   AJAX ADD TO CART
   Intercepts any <form action="/cart/add" method="post"> submission,
   posts JSON to /cart/add.js, shows a toast, updates the header badge.
   ============================================ */
(function () {
  var toast = null;
  var toastTimer = null;

  function ensureToast() {
    if (toast) return toast;
    toast = document.createElement("div");
    toast.className = "cart-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");
    toast.innerHTML =
      '<span class="cart-toast__ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>' +
      '<div class="cart-toast__body"><div class="cart-toast__title">Added to cart</div><div class="cart-toast__sub" data-toast-sub></div></div>' +
      '<div class="cart-toast__actions"><a class="cart-toast__btn cart-toast__btn--primary" href="/cart">View cart</a><button class="cart-toast__btn cart-toast__btn--ghost" type="button" data-toast-close aria-label="Dismiss">×</button></div>';
    document.body.appendChild(toast);
    toast.querySelector("[data-toast-close]").addEventListener("click", hideToast);
    return toast;
  }

  function showToast(title, sub, isError) {
    var t = ensureToast();
    var header = document.querySelector(".shopify-section-header");
    if (header) {
      var headerBottom = header.getBoundingClientRect().bottom;
      t.style.top = Math.max(88, Math.ceil(headerBottom + 16)) + "px";
    }
    t.querySelector(".cart-toast__title").textContent = title;
    t.querySelector("[data-toast-sub]").textContent = sub || "";
    t.classList.toggle("cart-toast__err", !!isError);
    t.classList.add("is-visible");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 4000);
  }

  function hideToast() {
    if (toast) toast.classList.remove("is-visible");
    if (toastTimer) { clearTimeout(toastTimer); toastTimer = null; }
  }

  function bumpCartBadge(count) {
    var badge = document.getElementById("headerCartBadge");
    var cart = document.getElementById("headerCart");
    if (!badge) return;
    if (count > 0) {
      badge.hidden = false;
      badge.textContent = count;
    } else {
      badge.hidden = true;
    }
    if (cart) {
      cart.classList.remove("is-pulse");
      // force reflow so the animation restarts
      void cart.offsetWidth;
      cart.classList.add("is-pulse");
    }
  }

  function fetchCartCount() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (c) { bumpCartBadge(c.item_count); return c; })
      .catch(function () {});
  }

  function handleSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;
    var action = (form.getAttribute("action") || "").toLowerCase();
    if (action.indexOf("/cart/add") === -1) return;
    // Don't intercept forms explicitly opted out
    if (form.hasAttribute("data-no-ajax")) return;

    e.preventDefault();

    var btn = form.querySelector('button[type="submit"], [type="submit"]');
    var origLabel = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.innerHTML = "Adding…"; }

    var fd = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.json().then(function (json) { return { ok: r.ok, json: json }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var msg = (res.json && (res.json.description || res.json.message)) || "Couldn't add to cart.";
          showToast("Couldn't add", msg, true);
          return;
        }
        var title = (res.json && (res.json.product_title || res.json.title)) || "Item added";
        var qty = (res.json && res.json.quantity) || 1;
        var sub = qty > 1 ? qty + " × " + title : title;
        showToast("Added to cart", sub, false);
        return fetchCartCount();
      })
      .catch(function () {
        showToast("Network error", "Couldn't reach the store — try again.", true);
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.innerHTML = origLabel; }
      });
  }

  document.addEventListener("submit", handleSubmit);
})();

/* ============================================
   BACK-TO-TOP BUTTON
   ============================================ */
(function () {
  var btn = document.getElementById("backToTop");
  if (!btn) return;

  var lastKnown = 0;
  var ticking = false;

  function update() {
    var showAfter = Math.max(400, window.innerHeight * 0.8);
    if (lastKnown > showAfter) {
      btn.hidden = false;
    } else {
      btn.hidden = true;
    }
    ticking = false;
  }

  window.addEventListener("scroll", function () {
    lastKnown = window.scrollY || window.pageYOffset;
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  btn.addEventListener("click", function () {
    var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, behavior: prefersReducedMotion ? "auto" : "smooth" });
  });
})();

/* ============================================
   HOMEPAGE SECTION NAV (floating side rail)
   Highlights current section on scroll, smooth-scrolls on click,
   remembers "hidden" state in localStorage per session
   ============================================ */
(function () {
  var nav = document.getElementById("homeNav");
  if (!nav) return; // only renders on homepage
  var opener = document.getElementById("homeNavOpen");
  var closeBtn = document.getElementById("homeNavClose");
  var items = Array.from(nav.querySelectorAll("li"));
  if (!items.length) return;

  // Map dataset.target -> element + nav <li>
  var pairs = items.map(function (li) {
    var link = li.querySelector("a");
    var targetId = link.getAttribute("data-target");
    var targetEl = targetId === "top"
      ? document.body
      : document.getElementById(targetId);
    return { li: li, link: link, targetEl: targetEl, targetId: targetId };
  }).filter(function (p) { return p.targetEl; });

  if (!pairs.length) return;

  // --- Smooth scroll on click (respects reduce-motion) + auto-close menu ---
  pairs.forEach(function (p) {
    p.link.addEventListener("click", function (e) {
      e.preventDefault();
      var prefersReduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (p.targetId === "top") {
        window.scrollTo({ top: 0, behavior: prefersReduced ? "auto" : "smooth" });
      } else {
        var headerOffset = 80;
        var y = p.targetEl.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top: y, behavior: prefersReduced ? "auto" : "smooth" });
      }
      // Auto-close the menu so it doesn't block the content the user just jumped to
      nav.hidden = true;
      if (opener) opener.hidden = false;
      try { sessionStorage.setItem("mc_homenav_open_v1", "0"); } catch (err) {}
    });
  });

  // --- Scroll spy: highlight section closest to top of viewport ---
  function updateActive() {
    var y = window.scrollY + 120; // header offset
    var activeIdx = 0;
    for (var i = 0; i < pairs.length; i++) {
      var p = pairs[i];
      if (p.targetId === "top") continue;
      var top = p.targetEl.getBoundingClientRect().top + window.scrollY;
      if (top <= y) activeIdx = i;
    }
    if (window.scrollY < 100) activeIdx = 0; // force "Top" when near top
    pairs.forEach(function (p, i) {
      p.li.classList.toggle("is-active", i === activeIdx);
    });
  }

  var ticking = false;
  window.addEventListener("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(function () { updateActive(); ticking = false; });
      ticking = true;
    }
  }, { passive: true });
  updateActive();

  // --- Hide / show behaviour + remember across pages in the session ---
  // Default state: nav hidden, opener visible. Only show the nav if the user
  // explicitly opened it earlier in this session.
  var STORAGE_KEY = "mc_homenav_open_v1";
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      nav.hidden = false;
      if (opener) opener.hidden = true;
    }
  } catch (e) { /* sessionStorage unavailable — fine */ }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      nav.hidden = true;
      if (opener) opener.hidden = false;
      try { sessionStorage.setItem(STORAGE_KEY, "0"); } catch (e) {}
    });
  }
  if (opener) {
    opener.addEventListener("click", function () {
      nav.hidden = false;
      opener.hidden = true;
      try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
    });
  }
})();

/* ============================================
   Electronic Parts hub: client-side SKU sort for oversized collections
   Shopify Liquid caps collection.products at 50 inside sections, so the
   server-rendered top-30 for collections with >50 products is a broken
   slice (it sorts whatever 50 Shopify handed us, missing the rest).
   For every .comp-section whose count exceeds 50, fetch ALL products
   via /collections/<handle>/products.json, natural-sort by first-variant
   SKU, and replace the tbody with the correct top rows.
   ============================================ */
(function () {
  // Scope to the parts hub ONLY. Individual collection pages render .comp-section
  // with data-category="all" too — if we matched those, the JS would fetch
  // /collections/all/products.json (Shopify's global product catalog) and
  // replace the collection's Liquid-sorted rows with unrelated top-SKU products.
  const hub = document.querySelector(".shopify-section-parts-hub");
  if (!hub) return;
  const sections = hub.querySelectorAll(".comp-section[data-category]");
  if (!sections.length) return;

  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

  function esc(s) {
    if (s == null) return "";
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function money(v) {
    if (v == null || v === "") return "";
    const n = typeof v === "number" ? v : parseFloat(v);
    if (isNaN(n)) return "";
    return "$" + n.toFixed(2);
  }

  async function fetchAllProducts(handle) {
    const all = [];
    for (let page = 1; page <= 20; page++) {
      let batch = [];
      try {
        const resp = await fetch("/collections/" + encodeURIComponent(handle) + "/products.json?page=" + page);
        if (!resp.ok) break;
        const data = await resp.json();
        batch = data.products || [];
      } catch (err) {
        console.warn("parts-hub SKU sort: fetch failed for", handle, "page", page, err);
        break;
      }
      if (!batch.length) break;
      all.push(...batch);
      if (batch.length < 30) break;
    }
    return all;
  }

  function skuKey(product) {
    const v = (product.variants && product.variants[0]) || {};
    return (v.sku || "zzzzzz").toLowerCase();
  }

  function renderRow(p) {
    const v = (p.variants && p.variants[0]) || {};
    const inStock = v.available !== false;
    const url = "/products/" + (p.handle || "");
    const sku = v.sku || "";
    const img = (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || null;
    const imgHtml = img
      ? '<img src="' + esc(img) + '" alt="' + esc(p.title || "") + '" width="60" height="60" loading="lazy">'
      : '<div class="pl-img__placeholder"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="3"/><path d="M7 8h10M7 12h10M7 16h10"/></svg></div>';
    const badge = inStock
      ? '<span class="stock-badge stock-badge--in">In stock</span>'
      : '<span class="stock-badge stock-badge--out">Out of stock</span>';
    const btnLabel = inStock ? "Add to Cart" : "Sold out";
    const btnAttr = inStock ? "" : "disabled";
    return (
      '<tr data-product-id="' + p.id + '" data-sku="' + esc(sku) + '">' +
      '<td class="pl-img"><div class="pl-img__wrap">' + imgHtml + '</div></td>' +
      '<td class="pl-name">' +
        '<a href="' + esc(url) + '" class="pl-name__link">' + esc(p.title || "") + '</a>' +
        '<div class="pl-name__meta">' +
          (p.vendor ? '<span class="pl-name__brand">' + esc(p.vendor) + '</span>' : "") +
          (sku ? '<span class="pl-name__sku">' + esc(sku) + '</span>' : "") +
        '</div>' +
      '</td>' +
      '<td class="pl-stock">' + badge + '</td>' +
      '<td class="pl-price"><div class="pl-price__main">' + money(v.price) + '</div><div class="pl-price__note">each</div></td>' +
      '<td class="pl-action">' +
        '<form action="/cart/add" method="post" enctype="multipart/form-data" class="pl-action__row">' +
          '<input type="hidden" name="id" value="' + (v.id || "") + '">' +
          '<div class="pl-qty">' +
            '<button class="pl-qty__btn" type="button" onclick="listQty(this,-1)" aria-label="Decrease quantity">−</button>' +
            '<input class="pl-qty__input" type="number" name="quantity" value="1" min="1" aria-label="Quantity">' +
            '<button class="pl-qty__btn" type="button" onclick="listQty(this,1)" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="btn-add-cart" type="submit" ' + btnAttr + '>' + btnLabel + '</button>' +
        '</form>' +
      '</td>' +
      '</tr>'
    );
  }

  async function resortSection(section) {
    const handle = section.dataset.category;
    if (!handle) return;
    const countEl = section.querySelector(".comp-section__count");
    const count = parseInt((countEl && countEl.textContent) || "0", 10) || 0;
    if (count <= 50) return; // server-side sort already covers the full collection

    const table = section.querySelector(".prod-list");
    const tbody = table && table.querySelector("tbody");
    if (!tbody) return;

    const products = await fetchAllProducts(handle);
    if (!products.length) return;

    products.sort((a, b) => collator.compare(skuKey(a), skuKey(b)));

    const cap = tbody.children.length || 30;
    tbody.innerHTML = products.slice(0, cap).map(renderRow).join("");
  }

  sections.forEach((section) => {
    resortSection(section)
      .catch((err) => {
        console.warn("parts-hub SKU sort failed for", section.dataset.category, err);
      })
      .finally(() => {
        // Reveal tbody regardless of success — either with new sorted rows, or
        // with whatever the server rendered (better visible-but-wrong than invisible).
        const table = section.querySelector(".prod-list");
        if (table) table.classList.add("is-sku-sorted");
      });
  });
})();
